// Helpers de formato compartidos por las secciones.
export const Format = {
  fecha: (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    if (isNaN(d)) return "—";
    return d.toLocaleDateString("es-AR");
  },

  fechaHora: (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    if (isNaN(d)) return "—";
    return d.toLocaleString("es-AR", { dateStyle: "short", timeStyle: "short" });
  },

  // Número "lindo": sin decimales si es entero, con coma decimal es-AR si no.
  num: (n) => {
    if (n === null || n === undefined) return "—";
    const v = Number(n);
    if (isNaN(v)) return "—";
    return Number.isInteger(v) ? String(v) : v.toLocaleString("es-AR", { maximumFractionDigits: 2 });
  },
};
